const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                    ['start', [this, 'block_start']],
                    ['end', [this, 'block_end']]
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                context.proxy[`tag_name`] = (((context.has(`tag_name`))) ? (this.env.getFilter('default').traceableCallable(1, this.source)(...[(context.has(`tag_name`) ? context.get(`tag_name`) : null), `div`])) : (`div`));
                this.echo(`
`);
                if ((context.has(`href`) ? context.get(`href`) : null)) {
                    this.echo(`  `);
                    context.proxy[`tag_name`] = `a`;
                }
                this.echo(`
`);
                context.proxy[`inner_tag_name`] = (((context.has(`inner_tag_name`))) ? (this.env.getFilter('default').traceableCallable(7, this.source)(...[(context.has(`inner_tag_name`) ? context.get(`inner_tag_name`) : null), `span`])) : (`span`));
                context.proxy[`start_tag_name`] = (((context.has(`start_tag_name`))) ? (this.env.getFilter('default').traceableCallable(8, this.source)(...[(context.has(`start_tag_name`) ? context.get(`start_tag_name`) : null), (context.has(`inner_tag_name`) ? context.get(`inner_tag_name`) : null)])) : ((context.has(`inner_tag_name`) ? context.get(`inner_tag_name`) : null)));
                context.proxy[`between_tag_name`] = (((context.has(`between_tag_name`))) ? (this.env.getFilter('default').traceableCallable(9, this.source)(...[(context.has(`between_tag_name`) ? context.get(`between_tag_name`) : null), (context.has(`inner_tag_name`) ? context.get(`inner_tag_name`) : null)])) : ((context.has(`inner_tag_name`) ? context.get(`inner_tag_name`) : null)));
                context.proxy[`end_tag_name`] = (((context.has(`end_tag_name`))) ? (this.env.getFilter('default').traceableCallable(10, this.source)(...[(context.has(`end_tag_name`) ? context.get(`end_tag_name`) : null), (context.has(`inner_tag_name`) ? context.get(`inner_tag_name`) : null)])) : ((context.has(`inner_tag_name`) ? context.get(`inner_tag_name`) : null)));
                this.echo(`
<`);
                this.echo(this.env.getFilter('escape').traceableCallable(12, this.source)(...[this.env, (context.has(`tag_name`) ? context.get(`tag_name`) : null), `html`, null, true]));
                this.echo(` class="c-dot-leader"
  `);
                if (this.compare((context.has(`tag_name`) ? context.get(`tag_name`) : null), `a`)) {
                    this.echo(`href="`);
                    this.echo(this.env.getFilter('escape').traceableCallable(13, this.source)(...[this.env, (((context.has(`href`))) ? (this.env.getFilter('default').traceableCallable(13, this.source)(...[(context.has(`href`) ? context.get(`href`) : null), `#`])) : (`#`)), `html`, null, true]));
                    this.echo(`"`);
                }
                this.echo(`>
  <`);
                this.echo(this.env.getFilter('escape').traceableCallable(14, this.source)(...[this.env, (context.has(`start_tag_name`) ? context.get(`start_tag_name`) : null), `html`, null, true]));
                this.echo(` class="c-dot-leader__start">
    `);
                this.traceableDisplayBlock(15, this.source)('start', context.clone(), blocks);
                this.echo(`  </`);
                this.echo(this.env.getFilter('escape').traceableCallable(18, this.source)(...[this.env, (context.has(`start_tag_name`) ? context.get(`start_tag_name`) : null), `html`, null, true]));
                this.echo(`>
  <`);
                this.echo(this.env.getFilter('escape').traceableCallable(19, this.source)(...[this.env, (context.has(`between_tag_name`) ? context.get(`between_tag_name`) : null), `html`, null, true]));
                this.echo(` class="c-dot-leader__between" aria-hidden="true"></`);
                this.echo(this.env.getFilter('escape').traceableCallable(19, this.source)(...[this.env, (context.has(`between_tag_name`) ? context.get(`between_tag_name`) : null), `html`, null, true]));
                this.echo(`>
  <`);
                this.echo(this.env.getFilter('escape').traceableCallable(20, this.source)(...[this.env, (context.has(`end_tag_name`) ? context.get(`end_tag_name`) : null), `html`, null, true]));
                this.echo(` class="c-dot-leader__end">
    `);
                this.traceableDisplayBlock(21, this.source)('end', context.clone(), blocks);
                this.echo(`  </`);
                this.echo(this.env.getFilter('escape').traceableCallable(31, this.source)(...[this.env, (context.has(`end_tag_name`) ? context.get(`end_tag_name`) : null), `html`, null, true]));
                this.echo(`>
</`);
                this.echo(this.env.getFilter('escape').traceableCallable(32, this.source)(...[this.env, (context.has(`tag_name`) ? context.get(`tag_name`) : null), `html`, null, true]));
                this.echo(`>
`);
            }

            block_start(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`      `);
                this.echo(this.env.getFilter('escape').traceableCallable(16, this.source)(...[this.env, (((context.has(`label`))) ? (this.env.getFilter('default').traceableCallable(16, this.source)(...[(context.has(`label`) ? context.get(`label`) : null), `Hello world`])) : (`Hello world`)), `html`, null, true]));
                this.echo(`
    `);
            }

            block_end(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`      `);
                this.echo(this.env.getFilter('escape').traceableCallable(22, this.source)(...[this.env, (((context.has(`count`))) ? (this.env.getFilter('default').traceableCallable(22, this.source)(...[(context.has(`count`) ? context.get(`count`) : null), 0])) : (0)), `html`, null, true]));
                this.echo(`
      <span class="u-hidden-visually">
        `);
                if (this.compare((context.has(`count`) ? context.get(`count`) : null), 1)) {
                    this.echo(`          `);
                    this.echo(this.env.getFilter('escape').traceableCallable(25, this.source)(...[this.env, (((context.has(`count_noun_single`))) ? (this.env.getFilter('default').traceableCallable(25, this.source)(...[(context.has(`count_noun_single`) ? context.get(`count_noun_single`) : null), `item`])) : (`item`)), `html`, null, true]));
                    this.echo(`
        `);
                }
                else {
                    this.echo(`          `);
                    this.echo(this.env.getFilter('escape').traceableCallable(27, this.source)(...[this.env, (((context.has(`count_noun_plural`))) ? (this.env.getFilter('default').traceableCallable(27, this.source)(...[(context.has(`count_noun_plural`) ? context.get(`count_noun_plural`) : null), `items`])) : (`items`)), `html`, null, true]));
                    this.echo(`
        `);
                }
                this.echo(`      </span>
    `);
            }

            getTemplateName() {
                return `6fe326c80a34f5da2cbfd40bd1025af58be50787e1d26eaa87733d666d8ab535`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `6fe326c80a34f5da2cbfd40bd1025af58be50787e1d26eaa87733d666d8ab535`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '6fe326c80a34f5da2cbfd40bd1025af58be50787e1d26eaa87733d666d8ab535');

let template = env.loadTemplate('6fe326c80a34f5da2cbfd40bd1025af58be50787e1d26eaa87733d666d8ab535');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/dot-leader/dot-leader.twig", args: context }
     );
     return rendered;;
};